<template>
  <v-row no-gutters :style="{ 'min-height': '100vh' }">
    <v-col cols="12" md="8" offset-md="2" lg="6" offset-lg="3" xl="4" offset-xl="4" class="pa-4">
      <div class="mt-10">
        <div class="text-center" style="height: 150px;">
          <lottie-player
            v-pre
            src="https://assets5.lottiefiles.com/private_files/lf30_eawk1khz.json"
            background="transparent"
            speed="1"
            loop
            autoplay
            style="width: 300px; height: 150px; display: inline;"
          ></lottie-player>
        </div>

        <h1 class="text-center mt-5 mb-3 text-h2">
          Contact
        </h1>
        <p class="text-center mb-10">Write to us for anything.</p>

        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent="send"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
        >
          <v-text-field
            outlined
            v-model="name"
            :rules="nameRules"
            label="Name"
            required
          ></v-text-field>

          <v-text-field
            outlined
            v-model="email"
            :rules="emailRules"
            label="E-mail"
            required
          ></v-text-field>

          <v-textarea
            outlined
            name="message"
            label="Your Message..."
            v-model="message"
            :counter="1000"
            :rules="messageRules"
          ></v-textarea>

          <input type="hidden" name="lastname" value="" />

          <v-checkbox
            v-model="newsletter"
            label="I want to get product emails and newsletters from Bookmark Expert"
          ></v-checkbox>

          <div class="text-right">
            <v-btn large color="primary" type="submit" :disabled="!valid" :loading="sending">
              SEND
            </v-btn>
          </div>
        </v-form>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Contact",
  metaInfo() {
    return this.generateMeta({ name: "contact", path: this.$route.path });
  },
  data() {
    return {
      valid: false,
      email: null,
      name: null,
      message: null,
      newsletter: false,
      sending: false,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 100) || "Name must be less than 100 characters",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      messageRules: [
        (v) => !!v || "Message is required",
        (v) => (v && v.length <= 100) || "Message must be less than 1000 characters",
      ],
    };
  },
  methods: {
    async send(e) {
      console.log("send");

      this.sending = true;

      try {
        let formData = new FormData();
        formData.append("name", this.name);
        formData.append("email", this.email);
        formData.append("message", this.message);
        formData.append("lastname", "itsme");

        let response = await fetch("/api/contact-form", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams(formData).toString(),
        });
        if (!response.ok) throw new Error("Not 2xx response");
        const data = await response.json();
        console.log(data, "data");

        this.$store.commit("updateStateSnackbar", {
          open: true,
          html: "We have got your message. We will respond as soon as possible.",
          icon: "success",
          timeout: 3000,
          action: "close",
        });

        if (this.newsletter) {
          this.$store.dispatch("newsletter", {
            subscribe: true,
            email: this.email,
            snackbar: false,
          });
        }

        this.name = "";
        this.email = "";
        this.message = "";
      } catch (e) {
        console.error(e);
        this.$store.commit("updateStateSnackbar", {
          open: true,
          html: "There is a problem. Please try again later.",
          icon: "error",
          timeout: 15000,
          action: "close",
        });
      }
      this.sending = false;
    },
  },
};
</script>
